export default __webpack_public_path__ + "static/media/Metamask.13e43ff7.svg";